<template>
  <!-- 10-3 医疗机构案件管理详情页面 -->
  <div class="main-css">
    <div class="main-box">
      <!----顶部条1---->
      <div class="up1-box">
        <div class="top-font1">
          <p>{{ $t("medicalInstitution") }}</p>
        </div>
        <div class="top1">
          <p>{{ jobDetails.medicalName }}</p>
        </div>
        <div class="top-font2">
          <p>{{ $t("caseNumber") }}</p>
        </div>
        <div class="top2">
          <p>{{ jobDetails.jobId }}</p>
        </div>
      </div>
      <!----顶部条2---->
      <div class="up2-box">
        <div class="box1">
          <div class="left-top-title">
            <p>{{ $t("projectTitle") }}</p>
          </div>
          <div class="left-bottom-title">
            <p>{{ jobDetails.jobName }}</p>
          </div>
        </div>
        <!---按钮--->
        <div class="box2">
          <button class="button-css" @click="handleFinalClick">
            {{ $t("endOfRecruitment") }}
          </button>
        </div>
      </div>
      <!-- 主要信息部分 -->
      <div class="main-info-box">
        <!-- 左边部分 -->
        <div class="left-box">
          <!-- 左边照片行 -->
          <div class="left-img-box">
            <img :src="imgList[0]" alt="" />
            <img :src="imgList[1]" alt="" />
            <img :src="imgList[2]" alt="" />
          </div>
          <!--左边第三行 -->
          <div class="label-line-box">
            <div :class="label1 ? 'label-box-active' : 'label-box'">
              {{ $t("foreignersWelcome") }}
              <span>×</span>
            </div>
            <div :class="label2 ? 'label-box-active' : 'label-box'">
              {{ $t("inexperiencedOK") }}
              <span>×</span>
            </div>
            <div :class="label3 ? 'label-box-active' : 'label-box'">
              {{ $t("newGraduateOK") }}
              <span>×</span>
            </div>
            <div :class="label4 ? 'label-box-active' : 'label-box'">
              {{ $t("educationalBackgroundMatter") }}
              <span>×</span>
            </div>
          </div>
          <!-- 左边第四行 -->
          <div class="inline-normal-box">
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("occupationCategory") }}
              </div>
              <div class="normal-bottom-box-name">
                {{
                  language === "CN"
                    ? jobDetails.workType_dictText
                    : jobDetails.jpworkType_dictText
                }}
              </div>
            </div>
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("workLocation") }}
              </div>
              <div class="normal-bottom-box-name">
                {{ jobDetails.workSpace }}
              </div>
            </div>
          </div>
          <!-- 左边第五行 -->
          <div class="inline-normal-box">
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("employmentForm") }}
              </div>
              <div class="normal-bottom-box-name">
                <span v-if="jobDetails.employmentForm1 == 1">{{
                  $t("fullTimeEmployee")
                }}</span>
                <span v-if="jobDetails.employmentForm2 == 1">{{
                  $t("partTimeJob")
                }}</span>
                <span v-if="jobDetails.employmentForm3 == 1">{{
                  $t("specificSkill")
                }}</span>
                <span v-if="jobDetails.employmentForm4 == 1">{{
                  $t("technicalInternTrainee")
                }}</span>
              </div>
            </div>
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("dutyTime") }}
              </div>
              <div class="normal-bottom-box-name">
                {{ jobDetails.workTime }}
              </div>
            </div>
          </div>
          <!-- 左边第六行 -->
          <div class="inline-normal-box">
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("salary") }}
              </div>
              <div class="normal-bottom-box-name">
                {{
                  language === "CN"
                    ? jobDetails.hourSalary_dictText
                    : jobDetails.jphourSalary_dictText
                }}<span style="margin-left: 10px"
                  >{{ jobDetails.startSalary }}~{{ jobDetails.endSalary }}</span
                >
              </div>
            </div>
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("numberOfHires") }}
              </div>
              <div class="normal-bottom-box-name">
                {{ jobDetails.recruitNumber }}
              </div>
            </div>
          </div>
          <!-- 左边第七行 -->
          <div class="inline-normal-box">
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("recruiter") }}
              </div>
              <div class="normal-bottom-box-name">
                {{ jobDetails.userName }}
              </div>
            </div>
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("targetRecruitmentTime") }}
              </div>
              <div class="normal-bottom-box-name">
                {{  jobDetails.principalTime&&jobDetails.principalTime.split(" ")[0] }}
              </div>
            </div>
          </div>
        </div>
        <!-- 右边部分 -->
        <div class="right-box">
          <!-- 第一行 -->
          <div class="right-normal-box">
            <div class="right-box-top">{{ $t("workContent") }}</div>
            <div class="right-box-bottom">
              {{ jobDetails.workContent }}
            </div>
          </div>
          <!-- 第二行 -->
          <div class="right-normal-box">
            <div class="right-box-top">{{ $t("welfare") }}</div>
            <div class="right-box-bottom">
              {{ jobDetails.welfareTreatment }}
            </div>
          </div>
          <!-- 第三行 -->
          <div class="right-normal-box">
            <div class="right-box-top">{{ $t("employmentConditions") }}</div>
            <div class="right-box-bottom">
              {{ jobDetails.employmentConditions }}
            </div>
          </div>
          <!-- 第四行 -->
          <div class="right-normal-box">
            <div class="right-box-top">{{ $t("other") }}</div>
            <div class="right-box-bottom">
              {{ jobDetails.other }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getUrlFromOSS,
  queryBasicInfo,
  selectJobDetailInfo,
  updateJobStatus,
  userUpdateJobStatus
} from "../../js/api";
import axios from "axios";
import AES from "../../js/AES";

export default {
  name: "medicalInstitutionCaseManagementDetails",
  components: {},
  data() {
    return {
      label1: 0,
      label2: 0,
      label3: 0,
      label4: 0,
      labelListHandle: [],
      jobDetails: [],
      userType: "",
      jobId: "",
      medicalName: "",
      imgList: [],
      language: ""
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    this.jobId = this.$route.query.jobId;
    this.showDetails();
    this.getAES();
    this.getMedicalName();
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key === "language" && e.newValue) {
        that.language = e.newValue;
      }
    },
    //图片回显
    getUrl(url) {
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口");
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(
              aesFecInfo.message ==
                "https://test202257.oss-cn-shanghai.aliyuncs.com/",
              "medicalInstitutionCaseManagementDetails"
            );
            if (
              aesFecInfo.message ==
                "https://test202257.oss-cn-shanghai.aliyuncs.com/" ||
              "https://test202257.oss-cn-shanghai.aliyuncs.com/null" ||
              aesFecInfo.message == ""
            ) {
              this.imgList.push(require("../../assets/avatar.png"));
              return;
            }
            this.imgList.push(aesFecInfo.message);
          }
        })
        .catch(() => {});
    },
    // 获取头部信息
    getAES() {
      var userInfo = localStorage.getItem("userInfo");
      const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
      console.log("---------------userInfo---------------");
      console.log(aesFecInfo, "头部信息");
      this.userType = aesFecInfo.roleName;
      console.log(this.userType, "类型");
    },
    getMedicalName() {
      queryBasicInfo()
        .then(res => {
          console.log("-----基本信息查询接口-----");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          this.medicalName = aesFecInfo.medicalName;
        })
        .catch(() => {});
    },
    showDetails() {
      console.log("获取案件详情" + this.jobId);
      const that = this;
      var jobIds = {
        jobId: that.jobId
      };
      selectJobDetailInfo(jobIds)
        .then(res => {
          console.log("--------求人信息详情查看接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            console.log("求人信息详情查看接口", res.data.data);
            const aesFecInfoData = JSON.parse(AES.decrypt(res.data.data));
            const aesFecInfo = aesFecInfoData.data[0];
            console.log(JSON.parse(AES.decrypt(res.data.data)));
            that.jobDetails = aesFecInfo;
            that.label1 = parseInt(aesFecInfo.label1) || 0;
            that.label2 = parseInt(aesFecInfo.label2) || 0;
            that.label3 = parseInt(aesFecInfo.label3) || 0;
            that.label4 = parseInt(aesFecInfo.label4) || 0;
            that.getUrl(aesFecInfo.jobPhoto1);
            that.getUrl(aesFecInfo.jobPhoto2);
            that.getUrl(aesFecInfo.jobPhoto3);
            console.log(aesFecInfo);
          }
        })
        .catch(res => {
          console.log("求人信息详情查看接口异常:", res);
        });
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("外国人歓迎") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("未経験 OK") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("新卒 OK") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("学歴問わない") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("外国人歓迎");
      } else if (num === 2) {
        this.labelListHandle.push("未経験 OK");
      } else if (num === 3) {
        this.labelListHandle.push("新卒 OK");
      } else if (num === 4) {
        this.labelListHandle.push("学歴問わない");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    handleFinalClick() {
      console.log("募集終了");
      if (this.jobDetails.reviewStatus == "2") {
        this.$message({
          message: this.$t("endOfRecruitment"),
          type: "warning"
        });

        return;
      }
      var fakeInfo = {
        jobId: this.jobId,
        reviewStatus: 4
      };
      //管理者变更案件状态接口
      if (this.userType === "medicalinstitutionadmin") {
        updateJobStatus(fakeInfo)
          .then(res => {
            console.log("-----管理者变更案件状态接口-----");
            console.log(res);
          })
          .catch(res => {});
      }
      //用户变更案件状态接口
      else if (this.userType === "medicalinstitutionuser") {
        userUpdateJobStatus(fakeInfo)
          .then(res => {
            console.log("-----用户变更案件状态接口-----");
            console.log(res);
          })
          .catch(res => {});
      }
      this.$router.push({
        path:
          "/administratorMedicalInstitutionRequestingCasesViewManagementList",
        name: "administratorMedicalInstitutionRequestingCasesViewManagementList"
      });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 95%;
  height: 100%;
  background: #fff;
}
.main-box {
  width: 95%;
  height: 100%;
  margin: 0 auto;
  /* padding: 0 55px; */
  padding-bottom: 70px;
  box-sizing: border-box;
}
.up1-box {
  margin-right: 1%;
  display: flex;
}
.top-font1 {
  margin-top: 23px;
  margin-right: 10px;

  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  align-items: center;
  letter-spacing: -0.02em;
  color: #686868;
  background: #ffffff;
}
.top-font2 {
  margin-top: 23px;
  margin-right: 10px;
  margin-left: 80px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  align-items: center;
  letter-spacing: -0.02em;
  color: #686868;
  background: #ffffff;
}
.top1 {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;
  padding: 3px 17px;
  margin-top: 20px;
  width: 300px;
  height: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  align-items: center;
  letter-spacing: -0.02em;
  /* 灰色字体 */
  color: #686868;
  background: #ffffff;
  /* 左边按钮颜色 */
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
}
.top2 {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;
  padding: 3px 17px;
  margin-top: 20px;

  width: 300px;
  height: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: -0.02em;
  /* 灰色字体 */
  color: #686868;
  background: #ffffff;
  /* 左边按钮颜色 */
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
}
.up2-box {
  width: 100%;
  height: 80px;
  margin-top: 50px;
  display: flex;
}
.box1 {
  height: 22px;
  width: 50%;
}
.box2 {
  height: 40px;
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}
.left-top-title {
  height: 24px;
  line-height: 22px;
  width: 520px;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 15px;
  color: #686868;
}
.left-bottom-title {
  height: 34px;
  width: 500px;
  line-height: 34px;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
}
.button-css {
  width: 150px;
  height: 40px;
  margin-left: 350px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
.main-info-box {
  width: 100%;
  height: 550px;
  display: flex;
}
.left-box {
  width: 550px;
}

.left-img-box {
  height: 114px;
  width: 80%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.left-img-box img {
  height: 114px;
  min-width: 50px;
  max-width: 150px;
  margin-right: 10px;
}

.label-line-box {
  width: 95%;
  height: 30px;
  margin-top: 15px;
}
.label-box {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  overflow: hidden;
  color: #fff;
  margin-right: 20px;
  margin-top: 10px;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-top: 10px;
  margin-right: 13px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.inline-normal-box {
  height: 85px;
  width: 95%;
  background: #fff;
  display: flex;
  margin-top: 15px;
}
.normal-box {
  width: 50%;
  height: 60px;
  padding: 0 15px;
  box-sizing: border-box;
}
.normal-top-box-name {
  width: 200px;
  height: 25px;
  box-sizing: border-box;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  line-height: 25px;
  color: #686868;
}
.normal-bottom-box-name {
  height: 35px;
  width: 200px;
  font-weight: 400;
  font-size: 14px;
  line-height: 35px;
  letter-spacing: 0.25px;
  color: #686868;
}

.right-box {
  /* width: 400px; */
  flex: 1;
  padding-top: 75px;
  box-sizing: border-box;
  padding-left: 50px;
  padding-right: 10px;
}
.right-normal-box {
  height: 105px;
  width: 90%;
  margin-bottom: 15px;
}
.right-box-top {
  height: 22px;
  line-height: 22px;
  width: 100%;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
}
.right-box-bottom {
  height: 80px;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalInstitutionCaseManagementDetails/index.vue